export default "__VITE_ASSET__C3dvy8cZ__"